(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationCreateFitBuilder',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// toggle global/custom banner fields
		$('.image-type > .btn-radio').click(function _imageTypeClicked() {
			var data_type = $(this).data('type');

			if (data_type === 'global') {
				// global banner
				$('.global-banner').removeClass('hidden');
				$('.custom-banner').addClass('hidden');
			} else {
				// custom banner
				$('.global-banner').addClass('hidden');
				$('.custom-banner').removeClass('hidden');
			}
		});

		$('#reservationcreatefitbuilder-packaged_by').change(function _adjustItemsBasedOnPackager() {
			switch ($(this).val()) {
				case 'supplier':
					$('.package-provider').removeClass('hidden');
					$('.component-packaged-by').addClass('hidden');

					$('.package-vendor-select').each(function _clearPackageVendorId() {
						$(this).val('');
					});
					break;
				case 'direct':
					$('.package-provider').addClass('hidden');
					$('.component-packaged-by').addClass('hidden');

					$('.package-vendor-select').each(function _clearPackageVendorId() {
						$(this).val('');
					});
					break;
				case 'mixed':
					$('.package-provider').addClass('hidden');
					$('.component-packaged-by').removeClass('hidden');
					break;
				default:
					console.log("nothing");
				break;
			}
		});

		$('.packaged_by > .btn-default').click(function _packagedByClicked() {
			var index = $(this).data('i');

			if ($(this).data('type') === 'supplier') {
				$('.component-package-vendor[data-i="' + index + '"]').removeClass('hidden');
			} else {
				$('.component-package-vendor[data-i="' + index + '"]').addClass('hidden');
			}
		});

		$('.package-vendor-select').change(function _adjustPackagedComponent() {
			var vendor_id = $(this).val(),
				i         = $(this).data('i'),
				$component_type_select;

			if (vendor_id.length > 0) {
				Adzuki.Ajax.get('/FitBuilders/packageSupportedTypes/' + vendor_id)
				.then(function _adjustSelections(response) {
					$component_type_select = $('.component-type[data-i="' + i + '"]');
					$component_type_select.empty();
					$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

					$.each(response, function _iterateTypes(index, element) {
						$component_type_select.append($('<option>').text(element).attr('value', index));
					});
				});
			}
		});

		$('#reservationcreatefitbuilder-primary_vendor_id').change(function _changePrimaryVendor() {
			var vendor_id = $(this).val(),
				$component_type_select;

			if (vendor_id.length > 0) {
				Adzuki.Ajax.get('/FitBuilders/packageSupportedTypes/' + vendor_id)
				.then(function _adjustSelections(response) {
					$component_type_select = $('.component-type');
					$component_type_select.empty();
					$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

					$.each(response, function _iterateTypes(index, element) {
						$component_type_select.append($('<option>').text(element).attr('value', index));
					});
				});
			}
		});

		Adzuki.Typeahead(
			'#reservationcreatefitbuilder-client_search',
			'/Clients/search',
			function select(item) {
				$('#reservationcreatefitbuilder-client_id').val(item.id);
				$('#reservationcreatefitbuilder-client_search').val(item.full_name);
				$('#reservationcreatefitbuilder-client_search').prop('disabled', true);

				$('.reset-client').removeClass('hidden');
			},
			function template(item) {
				var html;

				if (item.result_name) {
					html = item.result_name;
				} else {
					html = item.full_name;
				}

				html += item.age;

				return html;
			}
		);

		$('#reset-client-link').click(function _resetClient(e) {
			e.preventDefault();

			$('#reservationcreatefitbuilder-client_id').val('');
			$('#reservationcreatefitbuilder-client_search').val('');
			$('#reservationcreatefitbuilder-client_search').prop('disabled', false);
			$('.reset-client').addClass('hidden');
		});

		$('.reset-destination-link').click(function _resetDestination(e) {
			var num = $(this).data('i'),
				i   = num - 1;

			e.preventDefault();

			$('#reservationcreatefitbuilder-destination_search-' + i).val('');
			$('#reservationcreatefitbuilder-destination_search-' + i).prop('disabled', false);
			$('#reservationcreatefitbuilder-destination_id-' + i).val('');

			$('.reset-destination[data-i="' + num + '"]').addClass('hidden');
		});

		$('#reset-primary-vendor-link').click(function _resetPrimaryVendor(e) {
			e.preventDefault();

			$('#reservationcreatefitbuilder-primary_vendor_id').val('');
			$('#reservationcreatefitbuilder-vendor_search').val('');
			$('#reservationcreatefitbuilder-vendor_search').prop('disabled', false);
			$('.reset-primary-vendor').addClass('hidden');
		});

		$('.fit-builder-library-select').click(function _showImagePicker(e) {
			e.preventDefault();

			showImagePicker();
		});

		$('.remove-image').click(function _removeLibraryImage(e) {
			e.preventDefault();

			$('#reservationcreatefitbuilder-library_image').val('');
			$('.selected-image').attr('src', '');

			$('.selected-image-remove').addClass('hidden');
		});

		$('.reset-component-vendor').click(function _clearDetailLinks(e) {
			var num = $(this).data('i');

			e.preventDefault();

			$('.component_vendors[data-i="' + num + '"]').val('');
			$('.component_vendors[data-i="' + num + '"]').prop('disabled', false);
			$('.reset-typeahead[data-i="' + num + '"]').addClass('hidden');

			$('#reservationcreatefitbuilder-vendor_id-' + (num-1)).val('');

			loadVendorTypeAhead(num);

			if ($(this).val() === '') {
				$('.add-details-container[data-i="' + num + '"]').addClass('hidden');
				$('#fit-builder-details-type-' + num).val('');
			}
		});

		$('.fit-builder-detail-link').click(function _fitBuilderLink(e) {
			var num       = $(this).data('i'),
				type      = $('#fit-builder-details-type-' + num).val(),
				form_name = type.charAt(0).toUpperCase() + type.slice(1),
				vendor_id = $('#reservationcreatefitbuilder-vendor_id-' + (num -1)).val();

			e.preventDefault();

			$modal.addClass('wide');
			$modal.find('.modal-title').text('Add details');
			$modal.find('.modal-body').text('Loading form...');

			// might want to not do this for certain types
			// create an array with heights by type?
			$modal.find('.modal-body').css('min-height', '675px');

			Adzuki.Ajax.get('/FitBuilders/addComponentDetails/' + type + '/' + num + '/' + vendor_id)
			.then(function _showAddComponentDetails(html) {
				$modal.find('.modal-body').html(html);

				Adzuki.Form.initAjaxForm('FitBuilder' + form_name);

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		$modal.on('click', '.fit-builder-cancel', function _cancelModal(e) {
			e.preventDefault();

			$('.btn-default[data-dismiss="modal"]').trigger('click');
		});

		$('.remove-details').click(function _removeDetails(e) {
			var num = $(this).data('i');

			e.preventDefault();

			$('.add-details-container[data-i="' + num + '"]').addClass('hidden');
			$('#fit-builder-details-type-message-' + num).addClass('hidden');

			// eslint-disable-next-line no-unused-expressions
			$('#saved_details_' + num).val('');
		});

		loadVendorTypeAhead(1);
		loadDestinationTypeAhead(1);
	};

	function loadVendorTypeAhead(num)
	{
		var iterator = num - 1;

		Adzuki.Typeahead(
			'#reservationcreatefitbuilder-vendor_search-' + iterator,
			'/Vendors/search',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$('#reservationcreatefitbuilder-vendor_id-' + iterator).val(item.id);
				$('#reservationcreatefitbuilder-component_type-' + iterator).val(item.primary_component_type);

				 // eslint-disable-next-line no-lonely-if
				if ($('#reservationcreatefitbuilder-component_type-' + iterator).val() === item.primary_component_type) {
					// eslint-disable-next-line no-lonely-if
					if ($('#reservationcreatefitbuilder-component_type-' + iterator).val() === 'package') {
						$('.add-details-container[data-i="' + num + '"]').addClass('hidden');
						$('#fit-builder-details-type-' + num).val('');
					} else {
						$('.add-details-container[data-i="' + num + '"]').removeClass('hidden');
						$('#fit-builder-details-type-' + num).val(item.primary_component_type);
					}
				} else {
					$('.reset-component-vendor[data-i="' + num + '"]').trigger('click');
					Adzuki.StatusMessage('error', 'Sorry, the vendor you chose does not support the component type you selected above.');
					$('.component-type[data-i="' + num + '"]').val('');
				}
			}
		);
	}

	function loadDestinationTypeAhead(num)
	{
		var iterator = num - 1;

		Adzuki.Typeahead(
			'#reservationcreatefitbuilder-destination_search-' + iterator,
			'/Searches/destination/all/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$('#reservationcreatefitbuilder-destination_id-' + iterator).val(item.id);

				$('#reservationcreatefitbuilder-destination_search-' + iterator).val(item.name);
				$('#reservationcreatefitbuilder-destination_search-' + iterator).prop('disabled', true);
				$('.reset-destination[data-i="' + num + '"]').removeClass('hidden');
			}
		);
	}

	function showImagePicker()
	{
		$('.image-library-preview').attr('src', '');

		$modal.addClass('wide');
		$modal.find('.modal-title').text('Image Library');
		$modal.find('.modal-body').text('Loading image library...');

		Adzuki.Ajax.get('/Images/imagePicker')
		.then(function _showImagePicker(html) {
			$modal.find('.modal-body').html(html);

			Adzuki.Form.initAjaxForm('ImageSearch');
		});

		$modal.on('click', '.image-picker .select-image', function selectImage() {
			var $image = $(this).parents('.image-container').find('img'),
				$src = $image.attr('src');

			$('#reservationcreatefitbuilder-library_image').val($src);
			$('.selected-image').attr('src', $src);

			$('.selected-image-remove').removeClass('hidden');

			$modal.modal('hide');
		});

		$modal.on('click', '.add-button-btn', function addImageButtonPressed() {
			Adzuki.CustomConfirm({
				title  : 'Add image?',
				content: 'Adding images must be done through the Image section of the web program. Clicking \'Ok\' will take you there now. Would you like to go? Please note any unsaved work may be lost.',
				confirm: function confirm() {
					document.location = Adzuki.webprogram_url + Adzuki.base_uri + '/Images/add/';
				}
			});
		});

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal')
				  .off('click', '.image-picker .select-image');
		}).modal('show');
	}
}(jQuery, window.Adzuki || {}));
